'use client';
var COMPONENT_ID = "Center";
var defaultProps = {};

export { COMPONENT_ID, defaultProps };
